// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiMedicarePartD {
    static getAttributeTypeMap() {
        return PharmacyBiMedicarePartD.attributeTypeMap;
    }
}
PharmacyBiMedicarePartD.discriminator = undefined;
PharmacyBiMedicarePartD.additionalProperties = false;
PharmacyBiMedicarePartD.attributeTypeMap = [
    {
        "name": "catastrophicCoInsuranceValue",
        "baseName": "catastrophicCoInsuranceValue",
        "type": "string"
    },
    {
        "name": "currentStage",
        "baseName": "currentStage",
        "type": "string"
    },
    {
        "name": "gapCoInsuranceValue",
        "baseName": "gapCoInsuranceValue",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyBiMedicarePartD.js.map